import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addInventory = ({
  businessId,
  nickname,
  subcategory,
  type_vehicle,
  type_machinery,
  type_buildingcode,
  type_buildingmaterial,
  type_service,
  type_chemical,
  type_material,
  type_packaging,
  category,
  qty,
  life_expectancy,
  manuel,
  price_invoice,
  carbon,
  invoice_date,
  invoice_number,
  weight,
  building,
  manuel_unit,
  systemboundary_subcategory,
  subcategory_description,
  location,
  location_id,
  product_code,
  location_code,
  packaging_used_for,
  which_product_service,
  product_name,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
  triggerInvalidate = function () {
    return;
  },
}) => {
  const key = "add-new-inventory";
  var data = JSON.stringify({
    nickname: nickname,
    subcategory: subcategory,
    type_vehicle: type_vehicle,
    type_machinery: type_machinery,
    type_buildingcode: type_buildingcode,
    type_buildingmaterial: type_buildingmaterial,
    type_service: type_service,
    type_chemical: type_chemical,
    type_material: type_material,
    type_packaging: type_packaging,
    category: category,
    qty: qty,
    life_expectancy: life_expectancy || null,
    manuel: manuel || null,
    price_invoice: price_invoice || null,
    carbon: carbon || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    weight: weight || null,
    building: building,
    manuel_unit: manuel_unit,
    systemboundary_subcategory: systemboundary_subcategory,
    subcategory_description: subcategory_description,
    location: location || null,
    location_id: location_id || null,
    product_code: product_code || null,
    location_code: location_code || null,
    packaging_used_for: packaging_used_for || null,
    which_product_service: which_product_service || null,
    product_name: product_name || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (key) {
        triggerInvalidate(key);
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteInventory = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/" + businessId + "/inventory/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const updateInventory = ({
  businessId,
  objectId,
  objects,
  nickname,
  subcategory,
  type_vehicle,
  type_machinery,
  type_buildingcode,
  type_buildingmaterial,
  type_service,
  type_chemical,
  type_material,
  type_packaging,
  category,
  qty,
  life_expectancy,
  manuel,
  price_invoice,
  carbon,
  invoice_date,
  invoice_number,
  weight,
  building,
  manuel_unit,
  systemboundary_subcategory,
  subcategory_description,
  subcategoryId,
  location,
  location_id,
  product_code,
  location_code,
  packaging_used_for,
  which_product_service,
  product_name,
  buildingId = null,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    subcategory_obj: subcategoryId,
    building_obj: buildingId,
    nickname: nickname,
    subcategory: subcategory,
    type_vehicle: type_vehicle,
    type_machinery: type_machinery,
    type_buildingcode: type_buildingcode,
    type_buildingmaterial: type_buildingmaterial,
    type_service: type_service,
    type_chemical: type_chemical,
    type_material: type_material,
    type_packaging: type_packaging,
    category: category,
    qty: qty,
    life_expectancy: life_expectancy || null,
    manuel: manuel || null,
    price_invoice: price_invoice || null,
    carbon: carbon,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    weight: weight || null,
    building: building,
    manuel_unit: manuel_unit,
    systemboundary_subcategory: systemboundary_subcategory,
    subcategory_description: subcategory_description,
    location: location || null,
    location_id: location_id || null,
    product_code: product_code || null,
    location_code: location_code || null,
    packaging_used_for: packaging_used_for || null,
    which_product_service: which_product_service || null,
    product_name: product_name || null,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/inventory/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.type_vehicle = objectifyForDropdown(
              response.data.data.type_vehicle
            );
            response.data.data.type_machinery = objectifyForDropdown(
              response.data.data.type_machinery
            );
            response.data.data.type_buildingmaterial = objectifyForDropdown(
              response.data.data.type_buildingmaterial
            );
            response.data.data.type_service = objectifyForDropdown(
              response.data.data.type_service
            );
            response.data.data.type_chemical = objectifyForDropdown(
              response.data.data.type_chemical
            );
            response.data.data.type_material = objectifyForDropdown(
              response.data.data.type_material
            );
            response.data.data.type_packaging = objectifyForDropdown(
              response.data.data.type_packaging
            );
            response.data.data.location = objectifyForDropdown(
              response.data.data.location
            );
            response.data.data.product_name = objectifyForDropdown(
              response.data.data.product_name
            );
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getInventory = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      const sortedData = response.data.data
        .map((data) => {
          data.type_vehicle = objectifyForDropdown(data.type_vehicle);
          data.type_machinery = objectifyForDropdown(data.type_machinery);
          data.type_buildingmaterial = objectifyForDropdown(
            data.type_buildingmaterial
          );
          data.type_service = objectifyForDropdown(data.type_service);
          data.type_chemical = objectifyForDropdown(data.type_chemical);
          data.type_material = objectifyForDropdown(data.type_material);
          data.type_packaging = objectifyForDropdown(data.type_packaging);
          data.location = objectifyForDropdown(data.location);
          data.product_name = objectifyForDropdown(data.product_name);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getVehiclesInventory = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  subcategoryId = null,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.subcategory === "locality_vehicles" &&
            (subcategoryId === null || data.subcategory_obj === subcategoryId)
        )
        .map((data) => {
          data.type_vehicle = objectifyForDropdown(data.type_vehicle);
          data.location = objectifyForDropdown(data.location);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getMachineryInventory = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  subcategoryId = null,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.subcategory === "machinery" &&
            (subcategoryId === null || data.subcategory_obj === subcategoryId)
        )
        .map((data) => {
          data.type_machinery = objectifyForDropdown(data.type_machinery);
          data.location = objectifyForDropdown(data.location);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getChemicalsInventory = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  subcategoryId = null,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.subcategory === "chemicals" &&
            (subcategoryId === null || data.subcategory_obj === subcategoryId)
        )
        .map((data) => {
          data.type_chemical = objectifyForDropdown(data.type_chemical);
          data.location = objectifyForDropdown(data.location);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getBuildings = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  buildingName,
  buildingId,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.subcategory === "buildings" &&
            data.building === buildingName &&
            (buildingId === null || data.building_obj === buildingId)
        )
        .map((data) => {
          data.type_buildingmaterial = objectifyForDropdown(
            data.type_buildingmaterial
          );
          data.type_buildingcode = objectifyForDropdown(data.type_buildingcode);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPurchasedServicesInventory = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  subcategoryId = null,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.subcategory === "purchased_services" &&
            (subcategoryId === null || data.subcategory_obj === subcategoryId)
        )
        .map((data) => {
          data.type_service = objectifyForDropdown(data.type_service);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPackagingInventory = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  subcategory,
  subcategoryId = null,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.subcategory === subcategory &&
            (subcategoryId === null || data.subcategory_obj === subcategoryId)
        )
        .map((data) => {
          data.type_packaging = objectifyForDropdown(data.type_packaging);
          data.location = objectifyForDropdown(data.location);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCustomInventory = ({
  businessId,
  subcategory,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  subcategoryId,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.subcategory === subcategory &&
            (subcategoryId === null || data.subcategory_obj === subcategoryId)
        )
        .map((data) => {
          data.type_material = objectifyForDropdown(data.type_material);
          data.type_material = objectifyForDropdown(data.type_material);
          data.product_name = objectifyForDropdown(data.product_name);
          data.location = objectifyForDropdown(data.location);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createSystemBoundarySubcategory = ({
  businessId,
  systemBoundarySubcategory,
  subcategory,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    systemboundary_subcategory: systemBoundarySubcategory,
    name: subcategory,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/system-boundary-sub",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const getSystemBoundarySubcategory = ({
  businessId,
  setSystemBoundarySubCategory,
  subcategory,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/system-boundary-sub",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      name: subcategory,
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setSystemBoundarySubCategory(response.data.systemboundary_subcategory);
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const getCustomSubcategory = ({
  businessId,
  setCustomSubcategory = function () {
    return;
  },
  setSubcategoryNames = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory-custom",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setCustomSubcategory(response.data);
      const subNames = response.data.map((item) => {
        return item.name;
      });
      setSubcategoryNames(subNames);
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const updateSubcategory = ({
  businessId,
  objectId,
  objects,
  subcategory,
  subcategory_description,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: subcategory,
    subcategory_description: subcategory_description,
  });

  var config = {
    method: "put",
    url:
      baseUrl + "/api/business/" + businessId + "/inventory-custom/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(response.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const createSubcategory = ({
  businessId,
  objectId,
  objects,
  subcategory,
  subcategory_description,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
  triggerInvalidate = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: subcategory,
    subcategory_description: subcategory_description,
  });
  const key = "add-new-inventory-subcategory";

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/inventory-custom",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(response.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (key) triggerInvalidate(key);
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const deleteSubcategory = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  triggerInvalidate = function () {
    return;
  },
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl + "/api/business/" + businessId + "/inventory-custom/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");
  const key = "delete-inventory-subcategory";

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (key) triggerInvalidate(key);
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const updateBuilding = ({
  businessId,
  objectId,
  objects,
  building,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: building,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/inventory-buildings/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(response.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const createBuilding = ({
  businessId,
  objectId,
  objects,
  building,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
  triggerInvalidate = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: building,
  });

  const key = "add-new-inventory-building";

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/inventory-buildings",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(response.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (key) triggerInvalidate(key);
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const deleteBuilding = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  triggerInvalidate = function () {
    return;
  },
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/inventory-buildings/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");
  const key = "delete-inventory-building";
  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (key) triggerInvalidate(key);
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getBuildingsInventory = ({
  businessId,
  setBuildings,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/inventory-buildings",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setBuildings(response.data);
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};
